import { render, staticRenderFns } from "./LoginUserPasswordModifier.vue?vue&type=template&id=a4828650&"
import script from "./LoginUserPasswordModifier.vue?vue&type=script&lang=js&"
export * from "./LoginUserPasswordModifier.vue?vue&type=script&lang=js&"
import style0 from "./LoginUserPasswordModifier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports